import { DevolucionReadingDtoProps } from "./DTOs/DevolucionReadingDto"
import { DevolucionReadingFilteredDtoProps } from "./DTOs/DevolucionReadingFilteredDto"

export const devolucionReadingFilteredDtoAdapter = (
  devolucion: DevolucionReadingFilteredDtoProps
): DevolucionReadingFilteredDtoProps => ({
  id: devolucion?.id,
  descripcion: devolucion?.descripcion,
  fecha: devolucion?.fecha,
  identificador: devolucion?.identificador,
  importe: devolucion?.importe,
  razonSocial: devolucion?.razonSocial,
  remesado: devolucion?.remesado,
})

export const devolucionReadingDtoAdapter = (
  devolucion: DevolucionReadingDtoProps
): DevolucionReadingDtoProps => ({
  id: devolucion?.id,
  contactoId: devolucion?.contactoId,
  cuentaBancariaId: devolucion?.cuentaBancariaId,
  descripcion: devolucion?.descripcion,
  empresaId: devolucion?.empresaId,
  fecha: devolucion?.fecha,
  importe: devolucion?.importe,
  razonSocial: devolucion?.razonSocial,
})
